import React from 'react'

import ChangeQPPButtonLayout from '@components/Button/ChangeQuestionPerPageButton/ChangeQPPButtonLayout'
import useCurrentPage from '@hooks/useCurrentPage'

const ChangeQuestionPerPageButton = () => {
  const { questionPerPage: currentQuestionPerPage, setQuestionPerPage } = useCurrentPage()

  const props = {
    changeQuestionPerPage: (num: number) => setQuestionPerPage(num),
    currentQuestionPerPage,
  }
  // Todo 디자인 확정되면 반영 필요.
  return <ChangeQPPButtonLayout {...props} />
}

export default React.memo(ChangeQuestionPerPageButton)
